var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5143_9307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.248 8.27734C16.248 13.5273 9.49805 18.0273 9.49805 18.0273C9.49805 18.0273 2.74805 13.5273 2.74805 8.27734C2.74805 6.48713 3.45921 4.77024 4.72508 3.50437C5.99095 2.2385 7.70784 1.52734 9.49805 1.52734C11.2883 1.52734 13.0051 2.2385 14.271 3.50437C15.5369 4.77024 16.248 6.48713 16.248 8.27734Z",
    stroke: "#E52333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.5273C10.7426 10.5273 11.75 9.51998 11.75 8.27734C11.75 7.0347 10.7426 6.02734 9.5 6.02734C8.25736 6.02734 7.25 7.0347 7.25 8.27734C7.25 9.51998 8.25736 10.5273 9.5 10.5273Z",
    stroke: "#E52333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5143_9307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.777344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.8cab40236d98b972becb8d605091f387.svg";
export { ForwardRef as ReactComponent };